<template>
  <div id="app" :key="$i18n.locale">
    <router-view @start-new-chat="handleNewChat"></router-view>
    <SideBar
      v-if="showSidebar"
      ref="sidebar"
      @toggle-login="setShowLogin(true)"
      @start-new-chat="handleNewChat"
      @show-user-dialog="showUserDialog"
      @show-service-dialog="showServiceDialog"
      @show-set-dialog="showSetDialog"
    />
    <LoginPage v-if="showLogin" @close="setShowLogin(false)" />
    <transition name="slide-left">
      <!-- <chatList ref="chatList" @start-new-chat="handleNewChat" /> -->
    </transition>
    <UserDialog :dialogVisible="dialogVisible" @update="upadteDialog" />
    <SetDialog :settingVisible="settingVisible" @update="upadteSetDialog" />
    <ServiceDialog ref="serviceDialog"/>
    <DialogManager ref="dialogManager"/>
  </div>
</template>

<script>
import LoginPage from "./components/LoginPage.vue";
import SideBar from "./components/Sidebar.vue";
// import chatList from "./components/chatList.vue";
import UserDialog from "@/components/UserDialog";
import { mapState, mapMutations } from "vuex";
import SetDialog from "./components/setDialog.vue";
import ServiceDialog from "./components/ServiceDialog.vue";
import DialogManager from "./components/ThirdSide/DialogManager.vue";
import i18n from './i18n';

export default {
  components: {
    SideBar,
    LoginPage,
    // chatList,
    UserDialog,
    SetDialog,
    ServiceDialog,
    DialogManager
  },
  name: "App",
  data() {
    return {
      // showChatList: false, // 控制 chatList 显示状态
      dialogVisible: false,
      settingVisible: false,
      serviceVisible: false,
      referer: '',
      isResponding: false, // 用于标记是否正在响应
    };
  },
  computed: {
    ...mapState(["showLogin", "accessType", "token"]),
    showSidebar() {
      return this.$route.name !== "Privacy" && this.$route.path !== "/BadGateway" && this.$route.name !== "Manual" && this.$route.name !== "TpcPrivacy" && this.$route.name !== "WecomePage";
    },
  },
  methods: {
    ...mapMutations(["setShowLogin", "setAccessType", "setIstrial"]),
    handleNewChat() {
      if (this.$route.name !== 'ChatPage' || this.$route.query.id) {
    this.$router.push({ name: "ChatPage", query: {} }).catch(err => {
      if (err.name !== "NavigationDuplicated") console.error(err);
    });
  }
      this.$root.$emit("start-new-chat"); // 将事件广播到全局
    },
    showUserDialog(event) {
      this.dialogVisible = event; // 更新 dialogVisible 的值
    },
    showServiceDialog(event) {
      // this.serviceVisible = event; // 更新 serviceVisible 的值
      this.$refs.serviceDialog.showModal();
    },
    showSetDialog(event) {
      this.settingVisible = event; // 更新 settingVisible 的值
    },
    upadteDialog() {
      this.dialogVisible = false;
    },
    upadteSetDialog() {
      this.settingVisible = false;
    },

    // 获取当前页面的 referrer
    getReferer() {
      const referrer = document.referrer; // 获取当前页面的 referrer
      console.log('是否存在referrer:', this.referer, document); // 打印 referrer
      if(referrer){
        const refererDomain = new URL(referrer).origin;
        console.log('refererDomain:', refererDomain);
        if(refererDomain == 'https://ai.carbonneutrality-group.com/chat-app/' ||
          refererDomain == 'http://localhost:8080'){
          this.referer = '';
        }else{
          this.referer = refererDomain || ''; // 处理为空的情况
        }
      }else{
        this.referer = '';
      }
      // 将referer信息存储到Vuex中，供其他组件使用
      this.$store.commit('setReferer', this.referer);
    },
  },
  mounted() {
    // 监听全局事件并传递到当前路由页面
    this.$root.$on("start-new-chat", () => {
      const currentPage = this.$children.find(
        (child) => child.$options.name === this.$route.name
      );
      if (currentPage && currentPage.startNewChat) {
        currentPage.startNewChat();
      }
    });

    this.getReferer();
  },
  created() {
    // 获取 URL 参数
    const urlParams = new URLSearchParams(window.location.search);
    const encodedParams = urlParams.get('params');
    if (encodedParams) {
      try {
        const jsonParams = atob(decodeURIComponent(encodedParams));
        if(JSON.parse(jsonParams)?.is_trial){
          console.log("params:", JSON.parse(jsonParams)?.is_trial);
          this.setIstrial(true)
          if(!this.token){
            this.setShowLogin(true);
          }
        }
      } catch (error) {
        console.error('参数解析失败:', error);
      }
    }
  }
};
</script>

<style>
/* 左侧滑入动画 */
.slide-left-enter-active,
.slide-left-leave-active {
  transition: transform 0.3s ease, opacity 0.3s ease;
}
.slide-left-enter,
.slide-left-leave-to {
  transform: translateX(-100%);
  opacity: 0;
}

</style>
